<template>
  <v-container
    fluid
    fill-height
    class="pl-2 py-0 pr-0"
  >
    <v-row class="ma-0">
      <h2 class="page-title ">{{ title }}</h2>
      <v-divider vertical class="mx-4" />
      <v-btn
        small
        class="pa-2"
        text
        outlined
        plain
        v-text="'Add new ' + this.type"
      />
    </v-row>

    <v-stepper
      v-model="step"
      class="bt-stepper col-12 my-5 pa-0 no-background"
    >
      <v-stepper-header class="">
        <template v-for="s of steps">
          <v-divider v-if="s.step != 1" class="mx-0" />
          <v-stepper-step
            :editable="s.editable"
            :complete="s.completed"
            :step="s.step"
            :key="'stepper' + s.step"
            class="py-3 rounded-8"
          >
            {{ s.title }}
          </v-stepper-step>
        </template>
      </v-stepper-header>
    </v-stepper>

    <component
      v-for="s of steps"
      :key="'card-stepper-' + s.step"
      :is="s.component || 'Settings'"
      :expand="step == s.step"
      :title="s.title"
      :step="s.step"
      :extvalid.sync="s.valid"
      :exteditable.sync="s.editable"
      :extcompleted.sync="s.completed"
      v-model="s.form"
      :next="next"
    />


    <v-btn
      small
      color="primary"
      @click="save"
    >
      create
    </v-btn>
  </v-container>
</template>

<style>

  .v-stepper.no-background,
  .v-stepper .no-background {
    background: none;
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .bt-stepper .v-stepper__header {
    height: auto;
  }

  .bt-stepper.theme--light.v-stepper .v-stepper__step--editable.v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: rgba(0, 0, 0, 0.58);
  }

  .bt-stepper.theme--light.v-stepper .v-stepper__step--editable.v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {
    color: rgba(0, 0, 0, 0.88);
  }

</style>

<script>
  export default {
    props: {
      type: {},
    },

    components: {
      Settings: () => import('@/components/bonus-tools/forms/Settings'),
      Trigger: () => import('@/components/bonus-tools/forms/Trigger'),
      Segment: () => import('@/components/bonus-tools/forms/Segment'),
      Bonus: () => import('@/components/bonus-tools/forms/Bonus'),
    },

    data: () => ({
      steps: {
        settings: {
          title: 'Settings',
          component: 'Settings',
          step: 1,
          valid: false,
          form: {},
          editable: false,
          completed: false,
        },
        segment: {
          title: 'Segment',
          component: 'Segment',
          step: 2,
          valid: false,
          form: {},
          editable: false,
          completed: false,
        },
        trigger: {
          title: 'Trigger',
          component: 'Trigger',
          step: 3,
          valid: false,
          form: {},
          editable: false,
          completed: false,
        },
        bonus: {
          title: 'Bonus',
          component: 'Bonus',
          step: 4,
          valid: false,
          form: {},
          editable: false,
          completed: false,
        },
      },
      step: 1,
      titleMap: {
        autobonus: 'Autobonus',
        achievements: 'Achievements',
        period: 'Period',
        promocode: 'Promocode',
      }
    }),

    computed: {
      title: function () {
        return this.titleMap[this.type]
      }
    },

    methods: {
      next: function (step) {
        this.step = step + 1
      },
      save () {
      },
    },
  }
</script>
